import React from 'react';
import { placeholderReplace } from 'src/services/string-helper';
// import PnrFormComponent from '../pnr-form/pnr-form.component';
// models
import IDriverTrackingStatus from '../../models/driver-tracking-status.interface';
import ILocation from '../../models/location.interface';
import ITimeslot from '../../models/timeslot.interface';
import StatusList from '../arrival-status-list-component/status-list-component';
// styles
const styles = require('./arrival-driver-info.scss');
// images
const driverImgDefault = require('../../images/driver_default.jpg');

// const API_PATH = process.env.REACT_APP_API_URL;

interface IProps {
  locationData: ILocation;
  driverData: IDriverTrackingStatus;
  timeslotData: ITimeslot;
  locationType: string;
  queryParams: any;
  language: string;
  multiLang: any;
  trackingData: any;
}

interface IState {
  location: ILocation;
  timeslot: ITimeslot;
  driver: IDriverTrackingStatus;
  driverImg: string;
  locationType: string;
  driverStatusCopy: Array<string>;
}

class ArrivalDriverInfoComponent extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      location: props.locationData,
      driver: props.driverData,
      driverImg: props.driverData.driverInfo.imageURL !== null
        ? props.driverData.driverInfo.imageURL : driverImgDefault,
      timeslot: props.timeslotData,
      locationType: props.locationType,
      driverStatusCopy: ['Driver has arrived', 'Driver is running late', '	Driver en-route', '	Driver scheduled', '	Driver scheduled', 'Driver is running late', ' Driver scheduled']
    }
  }

  componentWillReceiveProps(props: IProps) {
    if (props.driverData !== null && props.timeslotData !== null) {
      this.setState({ driver: props.driverData });
      this.setState({
        driverImg: props.driverData.driverInfo.imageURL !== null
          ? props.driverData.driverInfo.imageURL : driverImgDefault
      });
      this.setState({ timeslot: props.timeslotData });
    }
  }

  public render() {
    const { language, multiLang } = this.props;
    const { driver } = this.state;

    const message = driver.translation ? driver.translation.message : driver.message ? driver.message : '';
    const parameters = driver.translation ? driver.translation.parameters : {};
    const { bagsJourney, driverTrackingStatus } = this.props.trackingData;
    const subTitle = multiLang[`${driverTrackingStatus.subTitle}${language}`] || driverTrackingStatus.subTitle;

    const placeHolerText: any = placeholderReplace(message, parameters);
    const text = isNaN(placeHolerText[0]) ? placeHolerText : placeHolerText[0] === '1' ? placeHolerText : '%s' + placeHolerText.substr(1)
    const description = multiLang[text + language]?.replace('%s', placeHolerText[0]) || placeHolerText;

    const {bookedBagCount, collectedBagCount} = driverTrackingStatus;
    const supportLink = {
      '': 'https://support.airportr.com/hc/en-us/articles/4403885089169-Arrivals-What-if-my-bag-isn-t-on-the-baggage-reclaim-at-my-destination',
      '_fr': 'https://support.airportr.com/hc/de/articles/4403885089169-Was-ist-wenn-mein-Gep%C3%A4ck-an-meinem-Zielort-nicht-auf-der-Gep%C3%A4ckausgabe-steht',
      '_de': 'https://support.airportr.com/hc/de/articles/4403885089169-Was-ist-wenn-mein-Gep%C3%A4ck-an-meinem-Zielort-nicht-auf-der-Gep%C3%A4ckausgabe-steht'
    };
    const warningMessage = multiLang['Bags collected from carousel' + language];
    return (
      <div className={styles.mainContent}>
        <div className={styles.group}>
          <div>
            <div className={styles.driver_wrapper}>
              {(collectedBagCount === bookedBagCount) && <h3>{subTitle}</h3>}
              <div className={styles.driver}>
                <img src={this.state.driverImg} />
                <div className={styles.driverInfo}>
                  <p>{this.state.driver.driverInfo.name ?? 'N/A'}</p>
                  <p className={styles.textAccent}>{multiLang[`${this.state.driverStatusCopy[this.state.driver.driverStatus - 1]}${language}`]}</p>
                  <div>
                    {(collectedBagCount === bookedBagCount) &&  <p className={styles.textMuted}>{placeholderReplace(multiLang[`${message}${language}`], parameters)}</p>}
                  </div>
                  <p className={styles.textMuted}>
                    {this.state.locationType === 'collection'
                      ? multiLang[`pickupAddressText${language}`]
                      : multiLang[`deliveryAddressText${language}`]
                    }
                  </p>
                  <p>{multiLang[`Postcode${language}`]}: {this.state.location.addressPostCode}</p>
                </div>
              </div>
                {(collectedBagCount !== bookedBagCount) && <div className=''>
                  <h4 className={styles.subHeading}>{subTitle}</h4>
                  <p className={[styles.warning, styles.description, styles.mb_12].join(' ')}>
                      {collectedBagCount + '/' + bookedBagCount + ' ' + warningMessage}
                    </p>
                  <p className={styles.description}>{description}</p>
                  <a target='_blank' href={supportLink[language]}>{multiLang['How do I find my missing bag?' + language]}</a>
                </div>}
            </div>
          </div>
          <div>
            <StatusList
                bagsJourney={bagsJourney}
                multiLang={multiLang}
                language={language}
                />
          </div>
        </div>
      </div>
    );

  };

};

export default ArrivalDriverInfoComponent;



// WEBPACK FOOTER //
// ./src/components/arrival-driver-info/arrival-driver-info.tsx